export enum ResolutionMode {
  FollowPlayerSetting = 'player',
  FollowWindowSize = 'window',
  FixedSize = 'fixed',
}

export interface IActPoint {
  /**
   * A random string that represents this act point.
   */
  id: string;
  tags?: string | string[];
  /**
   * Human readable name of this act point.
   */
  label: string;
  /**
   * The id of the episode.
   * @example `WhatIsNumber`, `HowToBuildAHouse`
   */
  firstLevelPath: string;
  /**
   * The id of the act point.
   * @example `P1`, `P2`
   */
  secondLevelPath: string;
  /**
   * Full path that concat first level path and second level path.
   */
  fullPath: string;
  /**
   * HTML file that generated by `ap-pack`.
   */
  entryPoints: {
    [uploader: string]: string;
  };
  /**
   * How to scale the act point on iFrame.
   */
  resolutionMode: ResolutionMode;
  /**
   * Width of the act point, only works if `resolutionMode` is `fixed`.
   */
  width: number;
  /**
   * Height of the act point, only works if `resolutionMode` is `fixed`.
   */
  height: number;
}
